import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { LoadingState } from '../../../utilities/constants';
import { FiRefreshCw, FiUpload } from 'react-icons/fi';
import PageHeader from '../../../components/PageHeader';
import UploadDataForm from './UploadDataForm';
import UploadDataTable from './UploadDataTable';
import { isEditableAuthorized } from '../../../app/userImpersonate';

const ManageUploadData = () => {
  const { t } = useTranslation();
  const isLoading = useSelector((state) => state.uploadData.status) === LoadingState.loading;
  const [reloadToken, setReloadToken] = useState(0);
  const [showUploadDataModal, setShowUploadDataModal] = useState(false);

  const closeModal = () => setShowUploadDataModal(false);
  const openModal = () => setShowUploadDataModal(true);

  const isEditable = isEditableAuthorized();
  const reloadListing = () => setReloadToken((token) => token + 1);
  const renderUploadBtn = () => (
    <Button variant="primary" onClick={openModal}>
      <FiUpload className="mr-1" />
      {t('Upload Emission Data')}
    </Button>
  );

  return (
    <Container fluid>
      <Row>
        <Col>
          <PageHeader
            title={t('Emission Data')}
            actions={
              <>
                <Button variant="secondary" className="mr-2" onClick={reloadListing} disabled={isLoading}>
                  <FiRefreshCw className="mr-1" />
                  {t('Refresh')}
                </Button>
                {isEditable && renderUploadBtn()}
              </>
            }
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <UploadDataTable reloadToken={reloadToken} />
        </Col>
      </Row>
      <UploadDataForm
        showModal={showUploadDataModal}
        closeModal={closeModal}
        onUploadHandler={reloadListing}
      />
    </Container>
  );
};

export default ManageUploadData;
